
import { useNavigate } from 'react-router-dom';
import './fixed-button.css';

export const FixedButton = ({title, ...rest}) => {
    const navigate = useNavigate();
   
    const handleClick = () => {
        if (rest?.link)
        {
            return navigate(rest.link);
        }
    }

    return (
        <div className="container fixed-btn-wrap d-flex justify-content-end align-items-center">
            <button {...rest} onClick={() => handleClick()}>
                {title}
                {rest?.count !== 0 &&
                        <div className="position-absolute top-0 translate-middle badge rounded-pill fw-bold">{rest?.count}</div>
                }
            </button>
        </div>
    )
}